<template>
  <div class="cloud-message-packets-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Valores Atendimentos
          </p>
        </div>
      </div>
      <div class="columns mt-6">
        <div
            class="column is-half"
            v-for="(messagePacket, index) in formData.plan.data.messagePackets"
            :key="index"
        >
          <div
              class="is-flex is-justify-content-center is-full"
          >
            <div
                class="box is-size-3 mx-4 p-6 has-text-centered is-fullwidth"
            >
              <div class="columns">
                <div class="column is-12">
                  <h1 class="is-size-2 has-text-weight-bold">
                    <span>
                      CLOUD
                    </span>
                  </h1>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full is-flex is-justify-content-center">
                  <div class="is-fit-width">
                    <div class="columns">
                      <div>
                        <div class="column pb-0 is-flex is-justify-content-center">
                          <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                          <span class="is-size-2 has-text-weight-semibold has-text-black">
                            {{ formatPrice(messagePacket.price) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span class="tag is-primary is-small is-size-6">
                    POR ATENDIMENTO RECEBIDO
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column pb-0 is-flex is-justify-content-center">
                  <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                  <span class="is-size-2 has-text-weight-semibold has-text-black">
                    {{ formatPrice(messagePacket.active_price) }}
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span class="tag is-primary is-small is-size-6">
                    POR ATENDIMENTO INICIADO
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <button
                      class="button is-primary is-size-5 is-medium has-text-weight-medium is-four-fifths"
                      @click.prevent="chooseMessagePacket(messagePacket)"
                  >
                    <div class="is-fullwidth">
                      Continuar
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="buttons is-flex is-justify-content-center is-full">
            <span class="is-size-4 has-text-centered has-text-grey-dark has-text-weight-bold dm-sans mb-4">
              Informações importantes
            </span>
          </div>
          <div
              class="is-flex is-justify-content-center is-full"
          >
            <table class="table">
              <tbody>
              <tr>
                <td class="is-relative">
                  <div class="center-blocked-element">
                    <font-awesome-icon
                        icon="fa-regular fa-circle"
                        color="black"
                        size="1x"
                    />
                  </div>
                </td>
                <td class="is-flex is-justify-content-start is-align-content-center ml-2">
                  <span>
                    <strong>
                      Os valores de mensalidade e implantação são pagos antes do uso, os atendimentos são pagos depois do uso;
                    </strong>
                  </span>
                </td>
              </tr>
              <tr>
                <td class="is-relative">
                  <div class="center-blocked-element">
                    <font-awesome-icon
                        icon="fa-regular fa-circle"
                        color="black"
                        size="1x"
                    />
                  </div>
                </td>
                <td class="is-flex is-justify-content-start is-align-content-center ml-2">
                  <span><strong>Um atendimento tem duração de 24 horas após primeira mensagem;</strong></span>
                </td>
              </tr>
              <tr>
                <td class="is-relative">
                  <div class="center-blocked-element">
                    <font-awesome-icon
                        icon="fa-regular fa-circle"
                        color="black"
                        size="1x"
                    />
                  </div>
                </td>
                <td class="is-flex is-justify-content-start is-align-content-center ml-2">
                  <span>
                    <strong>
                      Os valores e condições são referentes as políticas da Meta.inc (WhatsApp), podendo ocorrer mudanças.
                    </strong>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6">
      <div class="columns">
        <div class="column is-full is-flex is-justify-content-start is-align-content-start">
          <button
              class="button is-primary is-size-4 is-large has-text-weight-medium is-one-third"
              @click.prevent="$emit('previousTab')"
          >
            <div class="is-fullwidth">
              <span class="is-justify-content-start is-align-content-start has-text-left is-pulled-left">
                <
              </span>
              Escolher outro plano
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'messagePackets',

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  methods: {

    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },

    chooseMessagePacket(messagePacket) {
      this.formData.messagePacket.hasSum = messagePacket.mode === 2
      this.formData.messagePacket.showStep = true
      this.formData.messagePacket.data = messagePacket
      this.formData.messagePacket.data.quantity = 1
      this.formData.messagePacket.data.originalPrice = messagePacket.price
      const appStore = useAppStore()
      appStore.showReviewNextButton = true
    }

  },

  mounted() {
    const appStore = useAppStore()
    appStore.showReviewNextButton = false
  }

}

</script>

<style lang="scss" scoped>
$box-color: #000;

.center-blocked-element {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>